<template>
  <div class="commandsyncer">

    <Loading :show="!logs.length" />

    <h1>Synkronisering</h1>

    <h2>Boenden</h2>
    <button class="btn small" @click="sync('sync:accomodations', {
        accomodationId: ['accomodation', 'Boende-ID i databas eller slug', '']
      }, [
        '--update'
      ])">
      Boenden
    </button>
    <button class="btn small" @click="sync('sync:accomodations', {
      }, [
        '--only-check-new'
      ])">
      Endast nya boenden
    </button>
    <button class="btn small" @click="sync('sync:accomodationprices', {
        accomodationId: ['accomodation', 'Boende-ID i databas eller slug', ''],
        '--winter-prices': ['switch', 'VINTER: priser', true],
        '--winter-day-prices': ['switch', 'VINTER: dygnspriser', true],
        '--winter-availability': ['switch', 'VINTER: tillgänglighet', true],
        '--price-codes': ['text-readonly', 'Priskoder', 'all'],
        '--summer-prices': ['switch', 'SOMMAR: priser'],
        '--summer-availability': ['switch', 'SOMMAR: tillgänglighet'],
        '--next-winter-prices': ['switch', 'NÄSTA VINTER: priser', false, !SITE_CONFIG.next_season.winter.is_active],
        '--next-winter-availability': ['switch', 'NÄSTA VINTER: tillgänglighet', false, !SITE_CONFIG.next_season.winter.is_active],
      }, [])">
      Boendepriser
    </button>
    <button class="btn small" @click="sync('sync:accomodation_show_web')">
      Boenden: visa på webb
    </button>
    <button class="btn small" @click="sync('sync:accomodations_to_web')">
      Till Wordpress
    </button>

    <h2>Produkter</h2>
    <button class="btn small" @click="sync('sync:skiletting_products')">
      Skidhyra
    </button>
    <button class="btn small" @click="sync('sync:skipass')">
      Liftkort
    </button>
    <button class="btn small" @click="sync('sync:skischool')">
      Skidskola
    </button>

    <h2>Övrigt</h2>
    <button class="btn small" @click="sync('sync:promotion_codes')">
      Kampanjkoder
    </button>
    <button class="btn small" @click="sync('cache:prefetch')">
      Re-cache
    </button>

    <!-- <div>
      <button class="btn small" @click="sync('requeue:confirm', {
        step: ['text', 'Steg (1-5)', '1'],
        order: ['text', 'Order-ID', '']
      })">
        Bekräftelsesteg
      </button>
    </div> -->

    &nbsp;&nbsp;&nbsp;&nbsp;
    <hr />
    &nbsp;&nbsp;&nbsp;&nbsp;

    Visar de {{ count }} senaste

    <table>
      <thead>
        <tr>
          <th colspan="3">Status</th>
          <th colspan="2">Skapad</th>
          <th>ETA/Klart</th>
          <th>Jobb</th>
        </tr>
      </thead>
      <tbody v-for="log in logs">
        <tr :class="{success: log.success, failed: log.failed}">
          <td>
            <icon v-if="log.success" name="punklista-check" :scale="1" />
            <icon v-if="log.failed" name="error" :scale="1" />
            <span v-if="log.failed"><br>Fel</span>
            <span v-if="!log.success && !log.failed">Kör...</span>
          </td>
          <td>
            {{( log.done || 0) + '/' + (log.total_count || 1) }}
          </td>
          <td>
            {{( Math.min((((log.done || 0) / (log.total_count || 1)) * 100), 100 ).toLocaleString() )}}%
          </td>
          <td>
            <span style="white-space:pre;">{{ moment(log.created_at).format('D MMM') }}</span>
          </td>
          <td>
            {{ moment(log.created_at).format('HH:mm:ss') }}
          </td>
          <td v-if="log.success || log.failed">
            {{ moment(log.updated_at).format('HH:mm:ss') }}
          </td>
          <td :title="log.time_remaining + ' sekunder'" v-else>
            <span v-if="log.time_remaining">{{ moment().add(Math.abs(log.time_remaining), 'seconds').fromNow() }}</span>
            <span v-else>nu</span>
          </td>
          <td>
            <b>{{log.name}}</b><br />
            <i v-html="log.arguments"></i>
          </td>
        </tr>
      </tbody>
    </table>

    <button class="btn small" @click="getList(true)">Fler</button>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import API from '@/classes/API';
// import moment from 'moment';
import momentTz from 'moment-timezone';
import Loading from '@/components/components/Loading';

export default {
  components: {
    Loading,
  },
  data() {
    return {
      logs: [],
      shouldNotify: [],
      notified: [],
      intervalRef: null,
      count: 100,
    };
  },
  mounted() {
    this.getList();
    this.intervalRef = setInterval(this.getList, 10000);
  },
  destroyed() {
    clearInterval(this.intervalRef);
  },
  methods: {
    ...mapMutations([
      'openModal',
    ]),
    moment(arg) {
      return momentTz.tz(arg, 'UTC').tz('Europe/Stockholm');
    },
    notifyMe(log) {
      let notification = null;
      const msg = {
        title: log.name,
        body: (log.success ? 'Har kört klart!' : 'Gick inget bra :('),
        icon: 'https://www.branas.se/app/themes/branas/build/images/icons/apple-touch-icon-180x180-precomposed.png',
        image: 'https://www.branas.se/app/themes/branas/build/images/icons/apple-touch-icon-180x180-precomposed.png',
        badge: 'https://www.branas.se/app/themes/branas/build/images/icons/apple-touch-icon-180x180-precomposed.png',
      };
      if (!('Notification' in window)) {
        alert('This browser does not support desktop notification'); // eslint-disable-line
      } else if (Notification.permission === 'granted') {
        // If it's okay let's create a notification
        notification = new Notification(msg.title, msg);
      } else if (Notification.permission !== 'denied') {
        Notification.requestPermission((permission) => {
          // If the user accepts, let's create a notification
          if (permission === 'granted') {
            notification = new Notification(msg.title, msg);
          }
        });
      }
      console.log(notification);
    },
    async getList(addMore) {
      if (typeof addMore !== 'undefined' && addMore === true) {
        this.count = this.count + 100;
      }

      const { data } = await API.get(`/admin/command-logs?count=${this.count}`);
      this.logs = data;

      this.logs.forEach((log) => {
        // Already in sync queue
        if (this.shouldNotify.indexOf(log.id) !== -1) {
          // Done
          if (log.success) {
            this.shouldNotify.splice(this.shouldNotify.indexOf(log.id), 1);
            this.notified.push(log.id);
            this.notifyMe(log);
          }
        } else if (!log.success && !log.failed) {
          this.shouldNotify.push(log.id);
        }
      });
    },
    sync(command, args1, args2) {
      this.openModal(['AdminSyncFields', {
        command,
        args1,
        args2,
      }]);
    },
  },
  computed: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.commandsyncer
  admin-container()

table
  width 100%
th, td
  text-align left
  padding 2px 5px 2px 15px
  //width 25%
  border-bottom 1px solid lightgrey
  vertical-align: top;
  input
    font-weight normal
tbody tr:last-child td
  padding-bottom 20px
tr
  td
    admin-row-running()
  &.success
    td
      admin-row-completed()
  &.failed
    td
      admin-row-error()
input
  pading 2px 5px
</style>



// WEBPACK FOOTER //
// CommandSyncer.vue?591ecde2